module.exports = __webpack_public_path__ + "static/media/cookies.9b0d993c.svg";